export default {
  "navbar": {
    "sar": "9AR",
    "logout": "Log Out",
    "login": "Login",
    "search": "Search...",
    "userAvatar": "User Avatar",
    "admin": "Admin",
    "administrator": "Administrator",
    "apps": "Apps",
    "expand": "Expand",
    "notifications": "Notifications",
    "settings": "Settings",
    "logoutConfirmTitle": "Confirm Logout",
    "logoutConfirmMessage": "Are you sure you want to log out?",
    "logoutSuccess": "Logged out successfully",
    "logoutError": "Failed to logout. Please try again."
  },
  "menu": {
    "main": "Main",
    "settings": "Configuration",
    "homepage": "HomePage",
    "buy4meOrders": "Buy4Me Orders",
    "ship4meOrders": "Ship4Me Orders",
    "orderGroups": "Order Groups",
    "buyForMeGroups": "Buy4Me Groups",
    "shipForMeGroups": "Ship4Me Groups",
    "customers": "Customers",
    "users": "Users",
    "userRoles": "User Roles",
    "invoices": "Invoices",
    "paymentMethods": "Payment Methods",
    "paymentGateways": "Payment Gateways",
    "shippingCompanies": "Shipping Companies",
    "taxProfiles": "Tax Profiles",
    "currencies": "Currencies",
    "coupons": "Coupons",
    "categories": "Categories",
    "countries": "Countries",
    "cities": "Cities",
    "measurementUnits": "Measurement Units",
    "dangerousItems": "Dangerous Items",
    "faq": "FAQ",
    "faqCategories": "FAQ Categories",
    "contactRequests": "Contact Requests",
    "recovery": "System Recovery",
    "recaptchaSettings": "reCAPTCHA Settings",
    "cms": "Content Management",
    "sliders": "Sliders",
    "generalInfo": "General Info"
  },
  "common": {
    "welcome": "Welcome",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "search": "Search",
    "filter": "Filter",
    "export": "Export",
    "import": "Import",
    "refresh": "Refresh",
    "close": "Close",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "submit": "Submit",
    "reset": "Reset",
    "clear": "Clear",
    "select": "Select",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "next": "Next",
    "previous": "Previous",
    "first": "First",
    "last": "Last",
    "page": "Page",
    "of": "of",
    "items": "items",
    "item": "item",
    "total": "Total",
    "showing": "Showing",
    "to": "to",
    "from": "from",
    "show": "Show",
    "entries": "entries",
    "all": "All",
    "language": "Language",
    "english": "English",
    "arabic": "العربية",
    "orders": "Orders",

    // Form sections
    "basicInformation": "Basic Information",
    "shippingInformation": "Shipping Information",
    "productLink": "Product Link",
    "merchantName": "Merchant Name",
    "description": "Description",
    "quantity": "Quantity",
    "extendedDescription": "Extended Description",
    "originCountry": "Origin Country",
    "destinationCountry": "Destination Country",

    // Form placeholders
    "enterProductLink": "Enter product link",
    "enterMerchantName": "Enter merchant name",
    "enterDescription": "Enter description",
    "enterExtendedDescription": "Enter extended description",
    "selectOriginCountry": "Select Origin Country",
    "noDataFound": "No data found",
    "create": "Create",
    "update": "Update",
    "view": "View",
    "actions": "Actions",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "name": "Name",
    "code": "Code",
    "type": "Type",
    "category": "Category",
    "price": "Price",
    "amount": "Amount",
    "currency": "Currency",
    "collected": "Collected",
    "notCollected": "Not Collected",
    "date": "Date",
    "time": "Time",
    "email": "Email",
    "phone": "Phone",
    "address": "Address",
    "city": "City",
    "country": "Country",
    "notes": "Notes",
    "comments": "Comments",
    "updating": "Updating...",
    "selectOption": "Select an option",
    "permissions": "permissions"
  },
  "forms": {
    "name": "Name",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "phone": "Phone",
    "address": "Address",
    "city": "City",
    "country": "Country",
    "zipCode": "Zip Code",
    "description": "Description",
    "status": "Status",
    "date": "Date",
    "time": "Time",
    "amount": "Amount",
    "quantity": "Quantity",
    "price": "Price",
    "total": "Total",
    "discount": "Discount",
    "tax": "Tax",
    "shipping": "Shipping",
    "notes": "Notes",
    "comments": "Comments"
  },
  "validation": {
    "required": "This field is required",
    "email": "Please enter a valid email address",
    "password": "Password must be at least 8 characters",
    "confirmPassword": "Passwords do not match",
    "phone": "Please enter a valid phone number",
    "minLength": "Minimum length is {{min}} characters",
    "maxLength": "Maximum length is {{max}} characters",
    "min": "Minimum value is {{min}}",
    "max": "Maximum value is {{max}}"
  },
  "status": {
    "collected": "Collected",
    "notCollected": "Not Collected",
    "received": "Received",
    "notReceived": "Not Received"
  },
  "buttons": {
    "cancel": "Cancel",
    "selectAll": "Select All",
    "deselectAll": "Deselect All"
  },
  "table": {
    "number": "No",
    "id": "ID"
  },
  "select": "Select",
  "noOptions": "No options available",
  "loading": "Loading...",
  "actions": {
    "calculate": "Calculate",
    "calculating": "Calculating...",
    "reset": "Reset",
    "close": "Close",
    "back": "Back"
  },
  "messages": {
    "calculationSuccess": "Calculation completed successfully",
    "calculationFailed": "Calculation failed",
    "networkError": "Network error occurred"
  },
  "form": {
    "orderDetails": "Order Details",
    "link": "Product Link",
    "merchantName": "Merchant Name",
    "description": "Description",
    "quantity": "Quantity",
    "dimensions": "Dimensions",
    "width": "Width",
    "height": "Height",
    "length": "Length",
    "weight": "Weight",
    "pricing": "Pricing",
    "itemPrice": "Item Price",
    "shippingOptions": "Shipping Options",
    "originCountry": "Origin Country",
    "destinationCountry": "Destination Country",
    "shippingCompany": "Shipping Company",
    "currency": "Currency",
    "deliveryMode": "Delivery Mode",
    "itemType": "Item Type",
    "hasShippingInsurance": "Shipping Insurance",
    "enableDGFees": "Dangerous Goods Fees",
    "selectCountry": "Select Country",
    "selectShippingCompany": "Select Shipping Company",
    "selectCurrency": "Select Currency"
  },
  "deliveryMode": {
    "economy": "Economy",
    "fast": "Fast"
  },
  "itemType": {
    "normal": "Normal",
    "dangerous": "Dangerous"
  },
  "calculator": {
    "result": "Calculation Result",
    "orderPrice": "Order Price",
    "shippingCost": "Shipping Cost",
    "servicePrice": "Service Price",
    "totalPrice": "Total Price",
    "exchangeRate": "Exchange Rate",
    "dimensionalWeight": "Dimensional Weight",
    "actualWeight": "Actual Weight",
    "pricePerLB": "Price per LB",
    "insurance": "Insurance",
    "fuelCost": "Fuel Surcharge",
    "dgFees": "DG Fees",
    "shippingCompany": "Shipping Company",
    "currency": "Currency"
  },
  "orderGroups": {
    "kinds": {
      "buyForMe": {
        "title": "Buy For Me Groups",
        "subtitle": "Groups of Buy For Me items from one origin country",
        "detailsTitle": "Buy For Me Group #{{group}}"
      },
      "shipForMe": {
        "title": "Ship For Me Groups",
        "subtitle": "Groups of Ship For Me items from one origin country",
        "detailsTitle": "Ship For Me Group #{{group}}"
      }
    },
    "title": "Order Groups",
    "subtitle": "Every order is a group of items from one origin country",
    "detailsTitle": "Order Group #{{group}}",
    "detailsSubtitle": "Group totals, items, invoices and activity",
    "loading": "Loading...",
    "loadingItems": "Loading items...",
    "notFound": "Order group not found",
    "items": "Items",
    "emptyItems": "This group has no items",
    "empty": "No order groups found",
    "activeOfTotal": "Active items / all items",
    "yes": "Yes",
    "no": "No",
    "saving": "Saving...",
    "noteOptional": "Note (optional)",
    "messages": {
      "loadError": "Failed to load order groups",
      "actionFailed": "The action could not be completed",
      "invalidNumber": "Enter a number that is zero or more",
      "recalculated": "Group recalculated and saved",
      "itemRefunded": "Item refunded and group recalculated",
      "groupRefunded": "Order group refunded",
      "refundApproved": "Refund approved",
      "refundRejected": "Refund rejected",
      "statusChanged": "Item status updated"
    },
    "types": {
      "buyForMe": "Buy For Me",
      "shipForMe": "Ship For Me"
    },
    "payment": {
      "noInvoice": "No invoice",
      "paid": "Paid",
      "partial": "Partly paid",
      "pending": "Unpaid"
    },
    "columns": {
      "group": "Group",
      "type": "Type",
      "origin": "Origin",
      "destination": "Destination",
      "customer": "Customer",
      "items": "Items",
      "statuses": "Item statuses",
      "total": "Group total (USD)",
      "paid": "Paid (USD)",
      "remaining": "Remaining (USD)",
      "payment": "Payment",
      "created": "Created",
      "actions": "Actions",
      "number": "Number",
      "merchant": "Merchant",
      "quantity": "Quantity",
      "status": "Status",
      "invoice": "Invoice",
      "amount": "Amount (USD)",
      "method": "Payment method",
      "refund": "Refund",
      "date": "Date",
      "item": "Item",
      "summary": "Summary",
      "user": "User"
    },
    "filters": {
      "search": "Search",
      "searchPlaceholder": "Group number, item number, customer or country",
      "type": "Type",
      "allTypes": "All types",
      "status": "Item status",
      "allStatuses": "All statuses",
      "from": "Created from",
      "to": "Created to",
      "pendingRefund": "Only groups with a refund waiting for approval",
      "statusHint": "A group matches a status when any of its items has it."
    },
    "actions": {
      "viewItem": "View item",
      "open": "Open",
      "confirm": "Confirm",
      "cancel": "Cancel",
      "editItem": "Edit item",
      "manage": "Manage",
      "back": "Back"
    },
    "refund": {
      "pendingShort": "Refund pending",
      "pendingTotal": "Refund waiting for approval (USD)",
      "wholeGroup": "Refund whole group",
      "item": "Refund this item",
      "confirmItem": "Refund item {{item}} and recalculate the group?",
      "confirmGroup": "Refund every active item of group #{{group}}?",
      "confirmApprove": "Approve the refund of {{amount}} USD? Approve only after the money was handed back.",
      "confirmReject": "Reject the refund of {{amount}} USD?",
      "pending": "Pending approval",
      "completed": "Completed",
      "rejected": "Rejected",
      "amount": "Refund",
      "completedAmount": "Paid back",
      "approve": "Approve refund",
      "reject": "Reject refund"
    },
    "voucher": {
      "code": "Voucher code",
      "apply": "Apply voucher",
      "applied": "Voucher applied",
      "current": "Current group voucher: {{code}}",
      "groupNote": "The voucher applies to the whole group.",
      "title": "Voucher",
      "discount": "Voucher discount"
    },
    "summary": {
      "goodsValue": "Goods value (USD, not charged)",
      "serviceOnlyNote": "A Ship For Me group is charged for the service only; the goods are not part of the total.",
      "itemTotals": "Totals from the active items",
      "activeItems": "Active items",
      "chosenWeight": "Chargeable weight",
      "orderPrice": "Order price (USD)",
      "merchantFees": "Merchant delivery (USD)",
      "tax": "Tax (USD)",
      "insurance": "Insurance (USD)",
      "paymentFees": "Payment fees (USD)",
      "dangerous": "Dangerous goods"
    },
    "calc": {
      "title": "Group calculation",
      "ready": "Ready",
      "notReady": "Cannot be calculated yet",
      "shippingCompany": "Shipping company",
      "pricePerLb": "Price per LB",
      "shippingCost": "Shipping cost",
      "fuel": "Fuel surcharge",
      "dgFees": "DG fees",
      "localDelivery": "Local delivery",
      "clearance": "Clearance",
      "servicePrice": "Group service price",
      "commission": "Service charge (commission)",
      "total": "Group total",
      "chooseShippingCompany": "Choose a shipping company",
      "paymentType": "Payment type",
      "choosePaymentType": "Choose a payment type",
      "partialPercent": "First payment %",
      "partialPercentHint": "At least {{min}}%",
      "partialPercentFixed": "Fixed once the group is invoiced",
      "firstPayment": "First payment ({{percent}}%)",
      "paidAtDelivery": "Paid at delivery",
      "deliveryMode": "Delivery mode",
      "originCountry": "Origin country",
      "destinationCountry": "Destination country",
      "city": "City",
      "chooseCountry": "Choose a country",
      "chooseCity": "Choose a city",
      "chooseDeliveryMode": "Choose a delivery mode",
      "manualPrice": "Manual price per LB",
      "manualPricePlaceholder": "Empty = use the price table",
      "packaging": "Packaging",
      "save": "Recalculate & save",
      "unavailable": "The group calculation could not be loaded."
    },
    "invoices": {
      "title": "Group invoices",
      "closed": "Closed",
      "collected": "Collected",
      "pending": "Pending",
      "received": "Received",
      "downloadPdf": "Download PDF",
      "empty": "No group invoices"
    },
    "tabs": {
      "calculation": "Calculation",
      "summary": "Summary",
      "items": "Items",
      "invoices": "Invoices",
      "activity": "Activity / Log"
    },
    "itemEditor": {
      "title": "Item inputs",
      "loading": "Loading item…",
      "loadError": "The item inputs could not be loaded.",
      "readOnly": "You do not have permission to edit this item.",
      "termsMissing": "Choose the route (origin country, destination country and city), the payment type, the shipping company and the delivery mode of the group on the Calculation tab first. They apply to every item of the group.",
      "saved": "Item saved",
      "calculated": "Item calculated",
      "reset": "Item reset",
      "rejectNoteRequired": "A note is required to reject a pending item"
    },
    "itemTabs": {
      "details": "Details",
      "status": "Status",
      "log": "Log",
      "summary": "Summary"
    },
    "status": {
      "orderNumber": "Order number",
      "shippingOrderNumber": "Shipping order number",
      "reorderNumber": "Reorder number",
      "receiptNumber": "Courier receipt number",
      "paymentGateway": "Payment gateway",
      "chooseGateway": "Choose a gateway",
      "collectNote": "This change marks the open group invoices as collected.",
      "note": "Each item has its own status; the group has none.",
      "rejectedFinal": "This item was rejected and cannot be restored.",
      "cancelledFinal": "This item was cancelled and cannot be restored.",
      "acceptForCustomer": "Accept on behalf of the customer",
      "rejectForCustomer": "Reject on behalf of the customer",
      "newStatus": "New status",
      "choose": "Choose a status",
      "comment": "Comment",
      "reference": "Reference number",
      "apply": "Change status",
      "confirmAccept": "Accept item {{item}} on behalf of the customer?",
      "confirmReject": "Reject item {{item}} on behalf of the customer? A rejected item cannot be restored."
    },
    "activity": {
      "emptyItem": "No activity recorded for this item",
      "empty": "No activity recorded for this group",
      "group": "Group"
    }
  }
};
